import React from 'react'
import { Spinner } from 'react-bootstrap';
import styles from "./loadingCommentsComponent.module.css";
const LoadingCommentsComponent = () => {
  return (
    <div className={`${styles.mainContainer}`}>
        <Spinner style={{color:"#fff"}} animation="border" />
        <h3>Loading comments...</h3>
    </div>
  )
}

export default LoadingCommentsComponent;